module.exports = __webpack_public_path__ + "images/emoji/japanese_goblin.9750df1eecc9c37c61a3.png";